import { Notify } from "@/components/ui/notify";
import { useMqttIngestStatus } from "@/features/system/hooks";

/**
 * Banner global de degradação da ingestão MQTT.
 * Visível quando a bridge está sem conexão com o broker ("degraded") ou quando
 * o worker/bridge está fora do ar ("unknown"); some sozinho ao reconectar
 * ("connected") ou quando a bridge está desligada por decisão ("disabled").
 * Evita que NODATA generalizado seja lido como parada de fábrica.
 */
export function MqttDegradedBanner() {
  const { data, isError } = useMqttIngestStatus();
  // Falha ao buscar o status (não confundir com data.state) cai no mesmo copy
  // "indisponível" de state==="unknown": também é ausência de informação, não fato de degradação.
  if (!isError && (!data || (data.state !== "degraded" && data.state !== "unknown"))) return null;

  // Copys distintas: "degraded" é fato reportado pela bridge (broker fora);
  // "unknown"/erro de fetch é AUSÊNCIA de informação (worker fora/reiniciando, ou não deu pra
  // checar) — afirmar "sem conexão com o broker" seria falso em instalação sem broker (dev).
  const degraded = data?.state === "degraded";
  return (
    <div className="px-4 pt-4 md:px-6">
      <Notify.Banner
        variant="warning"
        title={
          degraded
            ? "Ingestão de sensores degradada"
            : "Status da ingestão de sensores indisponível"
        }
        description={
          degraded
            ? "A plataforma está sem conexão com o broker MQTT. Máquinas podem aparecer como Sem dados por falha de ingestão — não necessariamente por parada. A reconexão é automática."
            : "Não foi possível confirmar o status da ingestão de sensores (worker fora do ar ou reiniciando). Máquinas podem aparecer como Sem dados por falha de ingestão — não necessariamente por parada."
        }
      />
    </div>
  );
}
